import "core-js/modules/es6.regexp.replace.js";
var WorkerStatusCode = {
  DOWNLOAD_EXPERIMENT: 'DOWNLOAD_EXPERIMENT',
  LOAD_EXPERIMENT: 'LOAD_TO_MEMORY',
  STARTED_TASK: 'STARTED_TASK',
  COMPRESSING_TASK_DATA: 'COMPRESSING_DATA',
  UPLOADING_TASK_DATA: 'UPLOADING_DATA',
  FINISHED_TASK: 'FINISHED_TASK',
  // The worker has finished syncing and is polling an empty queue. It deliberately has no
  // display text: there is nothing to report, and getDisplayText returning undefined is
  // what clears the previous message.
  IDLE: 'IDLE'
};
var formattedTaskName = function formattedTaskName(taskName) {
  if (typeof taskName !== 'string') return '';

  // Remove "Get" from the name
  var nameWithoutGet = taskName.replace('Get', '');

  // Insert a space before capital letters, then trim
  var finalName = nameWithoutGet.replace(/([A-Z])/g, ' $1').trim();
  return finalName;
};
var getTaskNameToDisplay = function getTaskNameToDisplay(taskName) {
  if (taskName === 'ScTypeAnnotate') {
    return 'Annotate clusters';
  }
  return formattedTaskName(taskName);
};
var getDisplayText = function getDisplayText(statusCode, taskName) {
  var taskNameToDisplay = getTaskNameToDisplay(taskName);
  if (statusCode === WorkerStatusCode.DOWNLOAD_EXPERIMENT || statusCode === WorkerStatusCode.LOAD_EXPERIMENT) {
    return taskNameToDisplay ? "Accessing your analysis object for the requested task ".concat(taskNameToDisplay) : 'Accessing your analysis object';
  }
  if (statusCode === WorkerStatusCode.STARTED_TASK) {
    return "Working on the requested task ".concat(taskNameToDisplay);
  }
  if (statusCode === WorkerStatusCode.COMPRESSING_TASK_DATA) {
    return "Compressing the results for the requested task ".concat(taskNameToDisplay);
  }
  if (statusCode === WorkerStatusCode.UPLOADING_TASK_DATA) {
    return "Finalizing results for the requested task ".concat(taskNameToDisplay);
  }
  if (statusCode === WorkerStatusCode.FINISHED_TASK) {
    return "Displaying results for the requested task ".concat(taskNameToDisplay);
  }
};
export default WorkerStatusCode;
export { getDisplayText, getTaskNameToDisplay };